import React from "react";
import FigmaIcon from "./FigmaIcon";

export default function ProposalIcon(props) {
  return <FigmaIcon name="document" {...props} />;
}
